export default __webpack_public_path__ + "static/media/Kevin.25be2575.jpg";